var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',[_vm._v(" "+_vm._s(_vm.questionContents)+" ")]),_c('ul',[_c('div',{staticClass:"info_text",domProps:{"innerHTML":_vm._s(_vm.categoryDesc)}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }